import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const publicFileUrl = (path) => `${API}/public/files/${path}`;

export const fetchPrivateFile = async (path) => {
  const { data } = await api.get(`/files/${path}`, { responseType: "blob" });
  return URL.createObjectURL(data);
};

export const downloadCsv = async (url, params, fallbackName) => {
  const res = await api.get(url, { params, responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || fallbackName;
  const a = document.createElement("a");
  a.href = URL.createObjectURL(res.data);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
};

export const formatINR = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const apiError = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" ");
  return fallback;
};
